module.exports = __webpack_public_path__ + "static/media/v1.76e51b7e.mp4";